import React from 'react';

/**
 * Custom tooltip component for Recharts
 */
export const CustomTooltip = ({ active, payload, label, unit }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="tooltip-label">{label}</p>
        <p className="tooltip-value" style={{ color: payload[0].color }}>
          {payload[0].value?.toFixed(2)} {unit}
        </p>
      </div>
    );
  }
  return null;
};
